import { HttpEvent, HttpEventType } from '@angular/common/http';

import { DocContext } from 'app/services/doc-context/model';
import { MonoTypeOperatorFunction, pipe } from 'rxjs';
import { tap } from 'rxjs/operators';

/**
 * Set tab upload progress modal on http progress event
 *
 * @param uploadMsg - msg for upload modal
 * @param context
 */
export function setTabUploadPreloaderFromEvent<T>(
  uploadMsg: string | undefined,
  context?: DocContext,
): MonoTypeOperatorFunction<HttpEvent<T>> {
  if (!context || !uploadMsg) {
    return pipe();
  }

  return pipe(
    tap(event => {
      if (event.type === HttpEventType.UploadProgress) {
        const uploadProgress = Math.round((event.loaded / event.total!) * 100);
        context.setProgress({
          percent: uploadProgress,
          comment: uploadMsg,
          percentDisplay: true,
        });
      } else {
        context.setProgress(null);
      }
    }),
  );
}
